import _ from 'underscore';
import BaseView from '../../base-view';
import Model from './model';
import template from './template.html';

export default BaseView.extend({
	template: _.template(template),

	initialize: function() {
		// create new model
		this.model = new Model();

		// setup listeners
		this.listenTo(this.model, 'change:foreignCurrency', this.onCurrencyChange);
	},

	/**
	 * Currency change handler
	 * Fetch new data and update list
	 **/
	onCurrencyChange: function(model, currency) {
		this.model.fetch({
			data: {
				foreignCurrency: currency
			}
		}).then(
			this.renderList.bind(this),
			this.onFetchError.bind(this)
		);
	},

	/**
	 * Render list based on models in collection
	 * Warning: IE < 10 doesn't support innerHTML or insertAdjacentHTML on tbody (and others)
	 * despite the docs say otherwise: https://msdn.microsoft.com/en-us/library/ms535902%28v=vs.85%29.aspx#methods
	 * The method for altering tbody in IE < 10 isn't adviced since it's performance heavy
	 **/
	renderList: function() {
		var tableRows = this.template(this.model.toJSON()),
			tempNode,
			tempTable;

		// do it the fast, proper way
		if (!document.documentElement.classList.contains('lt-ie10')) {
			this.el.innerHTML = tableRows;
			return;
		}

		// here comes the pain

		// remove all rows in tbody
		while (this.el.rows[0]) {
			this.el.deleteRow(0);
		}

		// create temporarily div and table....
		tempNode = document.createElement('div');
		tempNode.innerHTML = '<table>' + tableRows + '</table>';
		tempTable = tempNode.firstChild;

		// move rows from tempTable to DOM table
		while (tempTable.rows[0]) {
			this.el.appendChild(tempTable.rows[0]);
		}
	},

	/**
	 * Fetch error handler
	 **/
	onFetchError: function(context, model, resp, options) {}
});
